"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.watchDuplicationStatus = void 0;
const clubWebSocket_1 = require("helpers/clubWebSocket");
const ui_1 = require("modules/ui");
const FOUR_MINUTES_IN_MILLISECONDS = 240000;
const CONTEXT_NAME = 'SingleContentDuplication';
const watchDuplicationStatus = ({ contextId, onReceive }) => {
    let clubWebsocket = null;
    const handleMessage = (response) => {
        if (response.status === clubWebSocket_1.StatusResponse.Success) {
            ui_1.UiService.setAlertSuccess('duplication_success', {});
            onReceive();
            clubWebsocket === null || clubWebsocket === void 0 ? void 0 : clubWebsocket.close();
        }
    };
    const handleError = () => {
        ui_1.UiService.setAlertError('duplication_error', {});
        onReceive();
        clubWebsocket === null || clubWebsocket === void 0 ? void 0 : clubWebsocket.close();
    };
    ui_1.UiService.setAlertInfo('duplication_loading', {});
    clubWebsocket = new clubWebSocket_1.ClubWebSocket({
        contextId,
        contextName: CONTEXT_NAME,
        messageTimeout: FOUR_MINUTES_IN_MILLISECONDS,
        onMessage: handleMessage,
        onError: handleError
    });
};
exports.watchDuplicationStatus = watchDuplicationStatus;
